import { useAuth } from 'src/auth/AuthContext';
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const loggedIn = useAuth().loggedIn;

  // App gates the router on the auth bootstrap (see App.tsx), so by the time
  // this renders `loggedIn` is settled — redirect during render rather than in
  // an effect, which would flash a frame of the protected page first.
  if (!loggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
